import { Alert, Box, Button, Group, Text } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { COLOR_ROLES } from './brandIdentity';

// A re-scan of an approved brand never overwrites it: the new look waits here for the client.
const ProposalBanner = ({ proposal, busy, onAccept, onDismiss }) => {
  const colors = proposal?.colors || {};
  const logo = proposal?.logoUrl || proposal?.logoDarkUrl;

  return (
    <Alert color="blue" variant="light" icon={<IconSparkles size={16} />} title="New version found on your website">
      <Text size="sm">Your website looks different from the brand saved here. Use the new version?</Text>
      <Group gap="xs" mt="xs" wrap="wrap">
        {logo && <img src={logo} alt="New logo" style={{ maxHeight: 24, maxWidth: 100 }} />}
        {COLOR_ROLES.filter(({ key }) => colors[key]).map(({ key, label }) => (
          <Box
            key={key}
            title={`${label}: ${colors[key]}`}
            role="img"
            aria-label={`${label}: ${colors[key]}`}
            style={{
              width: 18,
              height: 18,
              borderRadius: 4,
              background: colors[key],
              border: '1px solid rgba(0,0,0,0.15)',
            }}
          />
        ))}
      </Group>
      <Group gap="xs" mt="sm">
        <Button size="xs" onClick={onAccept} loading={busy === 'accept'} disabled={!!busy}>
          Accept
        </Button>
        <Button size="xs" variant="subtle" onClick={onDismiss} loading={busy === 'dismiss'} disabled={!!busy}>
          Dismiss
        </Button>
      </Group>
    </Alert>
  );
};

export default ProposalBanner;
